import "./style.css"

const platform = /Mac|iPhone|iPad/.test(navigator.platform)
  ? "darwin"
  : /Win/.test(navigator.platform)
    ? "win32"
    : "linux"

Object.defineProperty(globalThis, "process", {
  configurable: true,
  value: {
    env: {},
    nextTick(callback: () => void) {
      queueMicrotask(callback)
    },
    platform,
  },
})

void import("./mount").catch((cause) => {
  const error = cause instanceof Error ? cause : new Error(String(cause))
  document.documentElement.dataset.opencodeRuntime = "failed"
  const root = document.getElementById("opencode")
  if (root) root.textContent = `OpenCode failed to start: ${error.message}`
  console.error(error)
})
